import {
  PostApiSpoNeedAndSegmentationBody,
  SpoCreateUserNeedBody,
  SpoCreateUserNeedResponse,
  SpoNeedAndSegmentationResponse,
} from '@spo/types';
import { apiBff } from '.';

export const fetchNeedAndSegmentation = async (
  postApiSpoNeedAndSegmentationBody: PostApiSpoNeedAndSegmentationBody,
): Promise<SpoNeedAndSegmentationResponse> =>
  apiBff.callBFF(
    'POST',
    'spo/need_and_segmentation',
    postApiSpoNeedAndSegmentationBody,
  );

export const createUserNeed = async (
  spoCreateUserNeedBody: SpoCreateUserNeedBody,
): Promise<SpoCreateUserNeedResponse> =>
  apiBff.callBFF('POST', 'spo/create_user_need', spoCreateUserNeedBody);
